<template>
  <div class="min-h-screen relative overflow-hidden">
    <!-- <Transition name="fade-slide"> -->
    <!-- Background Blur Effects -->
    <!-- <div v-if="showContent" class="absolute inset-0 pointer-events-none -z-[100]">
        <div class="absolute -bottom-20 left-0 w-screen h-3/4 bg-gradient-to-t from-yellow-200/60 to-transparent mix-blend-multiply filter blur-3xl"></div>
        <div class="absolute -top-20 right-0 w-80 h-1/2 bg-gradient-to-t from-yellow-200/60 to-transparent rounded-full mix-blend-multiply filter blur-3xl"></div>
      </div> -->
    <!-- </Transition> -->
    <!-- Main Content -->
    <div class="min-h-screen flex items-stretch z-10">
      <!-- Left Column - Form -->
      <div class="flex-1 flex items-start justify-center px-4 sm:px-6 lg:px-8 py-8">
        <div class="w-full max-w-[480px]">
          <!-- Logo/Brand -->
          <Transition name="fade-slide">
            <div v-if="showContent" class="mb-8 text-left flex flex-row items-center justify-start">
              <div class="flex justify-center items-center border border-dark rounded-full p-4 w-fit">
                <img src="/images/CargoLink.svg" alt="CargoLink" class="h-6 w-auto" />
              </div>
            </div>
          </Transition>

          <!-- Header Section -->
          <Transition name="fade-slide">
            <div v-if="showContent" class="mb-4 text-center fade-slide-2">
              <h2 class="text-[32px] font-normal text-dark mb-2 leading-tight">
                <span v-if="formData.isDriver">Become a CargoLink Driver</span>
                <span v-else-if="formData.isCarrier">Become a CargoLink Carrier</span>
                <span v-else-if="formData.isForwarder">Become a CargoLink Forwarder</span>
                <span v-else-if="formData.isMover">Become a CargoLink Mover</span>
                <span v-else-if="formData.isWarehouseOperator">List Your Warehouse on CargoLink</span>
                <span v-else>Create an account</span>
              </h2>
              <p v-if="formData.isDriver" class="text-gray-500">Sign up to drive and earn with CargoLink</p>
              <p v-else-if="formData.isCarrier" class="text-gray-500">Sign up to set up your carrier business with CargoLink</p>
              <p v-else-if="formData.isForwarder" class="text-gray-500">Sign up to manage freight forwarding operations with CargoLink</p>
              <p v-else-if="formData.isMover" class="text-gray-500">Sign up to manage home and office moving jobs with CargoLink</p>
              <p v-else-if="formData.isWarehouseOperator" class="text-gray-500">Sign up to list and manage warehouse storage spaces on CargoLink</p>
              <p v-else class="text-gray-500">Sign up to get started shipping with CargoLink</p>
            </div>
          </Transition>

          <!-- Account Type Selection -->
          <Transition name="fade-slide">
            <div v-if="showContent" class="mb-8 fade-slide-2">
              <p class="text-sm font-medium text-dark mb-3">Select account type</p>
              <div class="grid grid-cols-2 gap-3">
                <!-- Shipper Option -->
                <button
                  type="button"
                  @click="formData.isDriver = false; formData.isCarrier = false; formData.isForwarder = false; formData.isMover = false; formData.isWarehouseOperator = false; formData.driverWorkforceType = ''"
                  class="relative p-2 rounded-xl border-2 transition-all duration-300 text-left group hover:border-dark/50"
                  :class="{
                    'border-green-500/10 bg-green-500/5': !formData.isDriver && !formData.isCarrier && !formData.isForwarder && !formData.isMover && !formData.isWarehouseOperator,
                    'border-gray-200 bg-white': formData.isDriver || formData.isCarrier || formData.isForwarder || formData.isMover,
                  }">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-colors duration-300"
                      :class="{
                        'bg-dark text-white': !formData.isDriver && !formData.isCarrier && !formData.isForwarder && !formData.isMover && !formData.isWarehouseOperator,
                        'bg-gray-100 text-gray-600 group-hover:bg-dark/10': formData.isDriver || formData.isCarrier || formData.isForwarder || formData.isMover,
                      }">
                      <Icon name="ph:package" class="w-5 h-5" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <h3 class="text-sm font-semibold text-dark mb-0.5">Shipper</h3>
                      <p class="text-xs text-gray-500 leading-snug">Ship cargo globally</p>
                    </div>
                  </div>
                  <div v-if="!formData.isDriver && !formData.isCarrier && !formData.isForwarder && !formData.isMover && !formData.isWarehouseOperator" class="absolute top-3 right-3 w-5 h-5 rounded-full bg-dark flex items-center justify-center">
                    <Icon name="ph:check" class="w-3 h-3 text-white" />
                  </div>
                </button>

                <!-- Driver Option -->
                <button
                  type="button"
                  @click="formData.isDriver = true; formData.isCarrier = false; formData.isForwarder = false; formData.isMover = false; formData.isWarehouseOperator = false; formData.driverWorkforceType = formData.driverWorkforceType || 'cityxpress'"
                  class="relative p-2 rounded-xl border-2 transition-all duration-300 text-left group hover:border-dark/50"
                  :class="{
                    'border-green-500/10 bg-green-500/5': formData.isDriver,
                    'border-gray-200 bg-white': !formData.isDriver,
                  }">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-colors duration-300"
                      :class="{
                        'bg-dark text-white': formData.isDriver,
                        'bg-gray-100 text-gray-600 group-hover:bg-dark/10': !formData.isDriver,
                      }">
                      <Icon name="ph:steering-wheel" class="w-5 h-5" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <h3 class="text-sm font-semibold text-dark mb-0.5">Driver</h3>
                      <p class="text-xs text-gray-500 leading-snug">Drive and earn</p>
                    </div>
                  </div>
                  <div v-if="formData.isDriver" class="absolute top-3 right-3 w-5 h-5 rounded-full bg-dark flex items-center justify-center">
                    <Icon name="ph:check" class="w-3 h-3 text-white" />
                  </div>
                </button>

                <!-- Carrier Option -->
                <button
                  type="button"
                  @click="formData.isCarrier = true; formData.isDriver = false; formData.isForwarder = false; formData.isMover = false; formData.isWarehouseOperator = false; formData.driverWorkforceType = ''"
                  class="relative p-2 rounded-xl border-2 transition-all duration-300 text-left group hover:border-dark/50"
                  :class="{
                    'border-green-500/10 bg-green-500/5': formData.isCarrier,
                    'border-gray-200 bg-white': !formData.isCarrier,
                  }">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-colors duration-300"
                      :class="{
                        'bg-dark text-white': formData.isCarrier,
                        'bg-gray-100 text-gray-600 group-hover:bg-dark/10': !formData.isCarrier,
                      }">
                      <Icon name="ph:truck" class="w-5 h-5" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <h3 class="text-sm font-semibold text-dark mb-0.5">Carrier</h3>
                      <p class="text-xs text-gray-500 leading-snug">Manage fleet</p>
                    </div>
                  </div>
                  <div v-if="formData.isCarrier" class="absolute top-3 right-3 w-5 h-5 rounded-full bg-dark flex items-center justify-center">
                    <Icon name="ph:check" class="w-3 h-3 text-white" />
                  </div>
                </button>

                <!-- Forwarder Option -->
                <button
                  type="button"
                  @click="formData.isForwarder = true; formData.isDriver = false; formData.isCarrier = false; formData.isMover = false; formData.isWarehouseOperator = false; formData.driverWorkforceType = ''"
                  class="relative p-2 rounded-xl border-2 transition-all duration-300 text-left group hover:border-dark/50"
                  :class="{
                    'border-green-500/10 bg-green-500/5': formData.isForwarder,
                    'border-gray-200 bg-white': !formData.isForwarder,
                  }">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-colors duration-300"
                      :class="{
                        'bg-dark text-white': formData.isForwarder,
                        'bg-gray-100 text-gray-600 group-hover:bg-dark/10': !formData.isForwarder,
                      }">
                      <Icon name="ph:shipping-container" class="w-5 h-5" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <h3 class="text-sm font-semibold text-dark mb-0.5">Forwarder</h3>
                      <p class="text-xs text-gray-500 leading-snug">Freight operations</p>
                    </div>
                  </div>
                  <div v-if="formData.isForwarder" class="absolute top-3 right-3 w-5 h-5 rounded-full bg-dark flex items-center justify-center">
                    <Icon name="ph:check" class="w-3 h-3 text-white" />
                  </div>
                </button>

                <!-- Movers Option -->
                <button
                  type="button"
                  @click="formData.isMover = true; formData.isForwarder = false; formData.isDriver = false; formData.isCarrier = false; formData.isWarehouseOperator = false; formData.driverWorkforceType = ''"
                  class="relative p-2 rounded-xl border-2 transition-all duration-300 text-left group hover:border-dark/50"
                  :class="{
                    'border-green-500/10 bg-green-500/5': formData.isMover,
                    'border-gray-200 bg-white': !formData.isMover,
                  }">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-colors duration-300"
                      :class="{
                        'bg-dark text-white': formData.isMover,
                        'bg-gray-100 text-gray-600 group-hover:bg-dark/10': !formData.isMover,
                      }">
                      <Icon name="ph:house-line" class="w-5 h-5" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <h3 class="text-sm font-semibold text-dark mb-0.5">Movers</h3>
                      <p class="text-xs text-gray-500 leading-snug">Home & office moves</p>
                    </div>
                  </div>
                  <div v-if="formData.isMover" class="absolute top-3 right-3 w-5 h-5 rounded-full bg-dark flex items-center justify-center">
                    <Icon name="ph:check" class="w-3 h-3 text-white" />
                  </div>
                </button>

                <!-- Warehouse Operator Option -->
                <button
                  type="button"
                  @click="formData.isWarehouseOperator = true; formData.isMover = false; formData.isForwarder = false; formData.isDriver = false; formData.isCarrier = false; formData.driverWorkforceType = ''"
                  class="relative p-2 rounded-xl border-2 transition-all duration-300 text-left group hover:border-dark/50"
                  :class="{
                    'border-green-500/10 bg-green-500/5': formData.isWarehouseOperator,
                    'border-gray-200 bg-white': !formData.isWarehouseOperator,
                  }">
                  <div class="flex items-start gap-3">
                    <div
                      class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-colors duration-300"
                      :class="{
                        'bg-dark text-white': formData.isWarehouseOperator,
                        'bg-gray-100 text-gray-600 group-hover:bg-dark/10': !formData.isWarehouseOperator,
                      }">
                      <Icon name="ph:warehouse" class="w-5 h-5" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <h3 class="text-sm font-semibold text-dark mb-0.5">Warehouse</h3>
                      <p class="text-xs text-gray-500 leading-snug">List & manage storage</p>
                    </div>
                  </div>
                  <div v-if="formData.isWarehouseOperator" class="absolute top-3 right-3 w-5 h-5 rounded-full bg-dark flex items-center justify-center">
                    <Icon name="ph:check" class="w-3 h-3 text-white" />
                  </div>
                </button>
              </div>
            </div>
          </Transition>

          <Transition name="fade-slide">
            <div v-if="showContent && formData.isDriver" class="mb-8 fade-slide-2">
              <p class="text-sm font-medium text-dark mb-3">Choose driver path</p>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <button
                  type="button"
                  @click="formData.driverWorkforceType = 'cityxpress'"
                  class="relative p-4 rounded-2xl border-2 transition-all duration-300 text-left"
                  :class="
                    formData.driverWorkforceType === 'cityxpress'
                      ? 'border-dark bg-dark text-white'
                      : 'border-gray-200 bg-white text-dark hover:border-dark/40'
                  ">
                  <div class="flex items-start gap-3">
                    <div
                      class="w-10 h-10 rounded-xl flex items-center justify-center"
                      :class="
                        formData.driverWorkforceType === 'cityxpress'
                          ? 'bg-white/15'
                          : 'bg-blue-50 text-blue-600'
                      ">
                      <Icon name="ph:lightning" class="w-5 h-5" />
                    </div>
                    <div class="min-w-0">
                      <h3 class="text-sm font-semibold mb-1">CityXpress Driver</h3>
                      <p
                        class="text-xs leading-snug"
                        :class="
                          formData.driverWorkforceType === 'cityxpress'
                            ? 'text-white/80'
                            : 'text-gray-500'
                        ">
                        Register yourself and your vehicle for CityXpress delivery jobs.
                      </p>
                    </div>
                  </div>
                </button>

                <button
                  type="button"
                  @click="formData.driverWorkforceType = 'intransit'"
                  class="relative p-4 rounded-2xl border-2 transition-all duration-300 text-left"
                  :class="
                    formData.driverWorkforceType === 'intransit'
                      ? 'border-dark bg-dark text-white'
                      : 'border-gray-200 bg-white text-dark hover:border-dark/40'
                  ">
                  <div class="flex items-start gap-3">
                    <div
                      class="w-10 h-10 rounded-xl flex items-center justify-center"
                      :class="
                        formData.driverWorkforceType === 'intransit'
                          ? 'bg-white/15'
                          : 'bg-indigo-50 text-indigo-600'
                      ">
                      <Icon name="ph:briefcase" class="w-5 h-5" />
                    </div>
                    <div class="min-w-0">
                      <h3 class="text-sm font-semibold mb-1">InTransit Worker</h3>
                      <p
                        class="text-xs leading-snug"
                        :class="
                          formData.driverWorkforceType === 'intransit'
                            ? 'text-white/80'
                            : 'text-gray-500'
                        ">
                        Apply for InTransit work-for-hire jobs. Vehicle details are not required.
                      </p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </Transition>

          <!-- Registration Form -->
          <Transition name="fade-slide">
            <form v-if="showContent" @submit.prevent="handleSubmit" class="space-y-6 self-center fade-slide-3">
              <!-- Full Name -->
              <div>
                <label class="text-sm font-medium text-dark mb-2 block">Full name</label>
                <div class="relative">
                  <Icon name="ph:user" class="absolute left-4 top-1/2 -translate-y-1/2" :class="errors.name && touched.name ? 'text-red-500' : 'text-gray-500'" />
                  <input
                    type="text"
                    v-model="formData.name"
                    @blur="validateField('name')"
                    placeholder="Enter your name"
                    :class="{
                      'border-red-500 focus:ring-red-500/20 focus:border-red-500': errors.name && touched.name,
                      'border-[#E8ECEF] focus:ring-primary/20 focus:border-primary': !errors.name || !touched.name,
                    }"
                    class="w-full pl-11 pr-4 py-[14px] rounded-xl border bg-white text-dark placeholder:text-gray-500 focus:outline-none focus:ring-2"
                    required />
                </div>
                <p v-if="errors.name && touched.name" class="mt-1 text-sm text-red-500">{{ errors.name }}</p>
              </div>

              <!-- Email -->
              <div>
                <label class="text-sm font-medium text-dark mb-2 block">Email</label>
                <div class="relative">
                  <Icon name="ph:envelope" class="absolute left-4 top-1/2 -translate-y-1/2" :class="errors.email && touched.email ? 'text-red-500' : 'text-gray-500'" />
                  <input
                    type="email"
                    v-model="formData.email"
                    @blur="validateField('email')"
                    placeholder="Enter your email"
                    :class="{
                      'border-red-500 focus:ring-red-500/20 focus:border-red-500': errors.email && touched.email,
                      'border-[#E8ECEF] focus:ring-primary/20 focus:border-primary': !errors.email || !touched.email,
                    }"
                    class="w-full pl-11 pr-4 py-[14px] rounded-xl border bg-white text-dark placeholder:text-gray-500 focus:outline-none focus:ring-2"
                    required />
                </div>
                <p v-if="errors.email && touched.email" class="mt-1 text-sm text-red-500">{{ errors.email }}</p>
              </div>

              <!-- Phone with Verification -->
              <div>
                <label class="text-sm font-medium text-dark mb-2 block">
                  Phone number
                  <span class="text-red-500">*</span>
                  <span v-if="phoneVerified" class="text-green-500 text-xs ml-2"> <Icon name="ph:check-circle" class="inline" /> Verified </span>
                </label>
                <div class="flex gap-2 items-center">
                  <div class="w-[120px]">
                    <CustomSelect
                      v-model="formData.countryCode"
                      :options="countryOptions"
                      :disabled="isLoadingCountries"
                      placeholder="Code"
                      @blur="validateField('countryCode')"
                      :modelValue="selectedCountryOption?.code"
                      @update:modelValue="(val) => (formData.countryCode = val)"
                      :class="{
                        'border-red-500': errors.countryCode && touched.countryCode,
                      }">
                      <template #option="{ option }">
                        <div class="flex items-center">
                          <img :src="option.flag" class="w-5 h-4 object-cover mr-2" :alt="option.name" />
                          <span>{{ option.label }}</span>
                        </div>
                      </template>
                      <template #prefix>
                        <img v-if="selectedCountryOption" :src="selectedCountryOption.flag" class="w-5 h-4 object-cover" :alt="selectedCountryOption.name" />
                      </template>
                      <template #selected="{ option }">
                        <span>{{ selectedCountryOption?.code || option?.code || "Select" }}</span>
                      </template>
                    </CustomSelect>
                  </div>
                  <div class="flex-1 relative">
                    <Icon name="ph:phone" class="absolute left-4 top-1/2 -translate-y-1/2" :class="phoneIconClass" />
                    <input
                      type="tel"
                      v-model="formData.phone"
                      @input="handlePhoneInput"
                      @blur="handlePhoneBlur"
                      placeholder="7** *** ***"
                      :disabled="phoneVerified"
                      class="w-full pl-11 pr-24 py-[14px] rounded-xl border bg-white text-dark placeholder:text-gray-500 focus:outline-none focus:ring-2"
                      :class="phoneInputClass"
                      required />
                    <button
                      v-if="isValidPhone && !phoneVerified"
                      @click="requestPhoneVerification"
                      type="button"
                      :disabled="isVerifying"
                      class="absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium px-3 py-1.5 bg-dark text-white rounded-lg hover:bg-dark/90 transition disabled:opacity-50">
                      {{ isVerifying ? "Sending..." : "Verify" }}
                    </button>
                  </div>
                </div>
                <p v-if="!phoneVerified && formData.phone && isValidPhone" class="mt-1 text-sm text-amber-600">Please verify your phone number before registering</p>
                <p v-if="errors.countryCode && touched.countryCode" class="mt-1 text-sm text-red-500">
                  {{ errors.countryCode }}
                </p>
                <p v-if="errors.phone && touched.phone" class="mt-1 text-sm text-red-500">
                  {{ errors.phone }}
                </p>
              </div>

              <!-- OTP Verification Modal -->
              <Modal :show="showOtpModal" title="Verify Phone Number" @close="closeOtpModal">
                <div class="p-6">
                  <div class="text-center mb-6">
                    <div class="w-16 h-16 bg-dark/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon name="ph:device-mobile" class="text-dark text-3xl" />
                    </div>
                    <p class="text-sm text-gray-600">
                      Enter the 6-digit code sent to<br />
                      <span class="font-medium text-dark">{{ formData.countryCode }} {{ formData.phone }}</span>
                    </p>
                  </div>

                  <OtpInput v-model="otpCode" :length="6" @complete="verifyPhoneOtp" class="mb-6" />

                  <!-- Verify Button -->
                  <button
                    @click="verifyPhoneOtp(otpCode)"
                    type="button"
                    :disabled="isVerifying || otpCode.length !== 6"
                    class="w-full bg-dark text-white rounded-xl py-3 font-medium hover:bg-dark/90 transition-colors focus:outline-none focus:ring-2 focus:ring-dark/20 disabled:opacity-70 disabled:cursor-not-allowed mb-6">
                    <span class="flex items-center justify-center">
                      <Icon v-if="isVerifying" name="svg-spinners:180-ring" class="mr-2 h-5 w-5" />
                      {{ isVerifying ? "Verifying..." : "Verify Code" }}
                    </span>
                  </button>

                  <div class="flex items-center justify-center gap-2 text-sm mb-6">
                    <span class="text-gray-600">Didn't receive code?</span>
                    <button v-if="otpCountdown > 0" type="button" disabled class="text-gray-400 cursor-not-allowed">Resend in {{ otpCountdown }}s</button>
                    <button v-else @click="requestPhoneVerification" type="button" :disabled="isVerifying" class="text-dark font-medium hover:underline disabled:opacity-50">Resend Code</button>
                  </div>

                  <button @click="closeOtpModal" type="button" class="w-full py-3 text-gray-600 hover:text-dark transition-colors font-medium">Cancel</button>
                </div>
              </Modal>

              <!-- Password -->
              <div>
                <label class="text-sm font-medium text-dark mb-2 block">Password</label>
                <div class="relative">
                  <Icon name="ph:lock" class="absolute left-4 top-1/2 -translate-y-1/2" :class="errors.password && touched.password ? 'text-red-500' : 'text-gray-500'" />
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="formData.password"
                    @blur="validateField('password')"
                    placeholder="Enter your password"
                    :class="{
                      'border-red-500 focus:ring-red-500/20 focus:border-red-500': errors.password && touched.password,
                      'border-[#E8ECEF] focus:ring-primary/20 focus:border-primary': !errors.password || !touched.password,
                    }"
                    class="w-full pl-11 pr-11 py-[14px] rounded-xl border bg-white text-dark placeholder:text-gray-500 focus:outline-none focus:ring-2"
                    required />
                  <button type="button" @click="showPassword = !showPassword" class="absolute right-4 top-1/2 -translate-y-1/2 hover:text-dark" :class="errors.password && touched.password ? 'text-red-500' : 'text-gray-500'">
                    <Icon v-if="showPassword" name="ph:eye-slash" class="w-5 h-5" />
                    <Icon v-else name="ph:eye" class="w-5 h-5" />
                  </button>
                </div>
                <p v-if="errors.password && touched.password" class="mt-1 text-sm text-red-500">{{ errors.password }}</p>
              </div>

              <!-- Submit Button -->
              <button
                type="submit"
                class="w-full bg-dark text-white rounded-xl py-[14px] font-medium hover:bg-dark/90 transition-colors focus:outline-none focus:ring-2 focus:ring-dark/20 disabled:opacity-70 disabled:cursor-not-allowed mt-2"
                :disabled="isLoading">
                <span class="flex items-center justify-center">
                  <Icon v-if="isLoading" name="svg-spinners:180-ring" class="mr-2 h-5 w-5" />
                  {{ isLoading ? "Creating Account..." : "Submit" }}
                </span>
              </button>

              <!-- Sign In Link -->
              <p class="text-center text-gray-500 text-sm mt-8">
                Already have an account?
                <NuxtLink to="/auth/login" class="text-dark font-medium hover:text-dark/80 transition-colors ml-1 underline"> Sign in </NuxtLink>
              </p>
              <div class="flex items-center justify-center">
                <span class="px-2 text-gray-500 text-xs text-center"
                  >By signing up, you agree to our <NuxtLink to="/terms" class="text-dark font-medium hover:text-dark/80 transition-colors ml-1 underline">Terms of Service</NuxtLink> and
                  <NuxtLink to="/privacy" class="text-dark font-medium hover:text-dark/80 transition-colors ml-1 underline">Privacy Policy</NuxtLink></span
                >
              </div>
            </form>
          </Transition>
        </div>
      </div>

      <!-- Right Column - Image -->
      <div class="hidden lg:flex w-1/2 relative p-12">
        <div class="relative w-full max-w-4xl mx-auto aspect-[4/3]">
          <Transition name="fade-slide">
            <img v-if="showContent" src="/images/auth/Truck3dOnroad.png" alt="Large truck on the road" class="w-full h-full object-cover rounded-[40px]" />
          </Transition>
          <!-- Overlay -->
          <!-- <div class="absolute inset-0 bg-gradient-to-t from-yellow-900/30 to-transparent rounded-[40px]"></div> -->

          <!-- Floating Cards -->
          <Transition name="fade-slide" @after-enter="startFloating">
            <div v-if="showContent" class="absolute inset-0 p-8 fade-slide-4" :style="floatingStyle">
              <!-- Top Stacked Cards -->
              <div class="relative ml-8 mt-8">
                <!-- First Card -->
                <div class="bg-yellow-200/80 backdrop-blur-md p-4 rounded-2xl mb-4 absolute top-0 left-0 w-[280px] z-20">
                  <div class="flex flex-row justify-between">
                    <h3 class="text-sm font-semibold text-dark/80 mb-1">Fast Delivery</h3>
                    <div class="rounded-full bg-dark/80 w-2 h-2"></div>
                  </div>
                  <p class="text-xs text-gray-600">Get your cargo delivered quickly and efficiently across borders</p>
                </div>
                <!-- Second Card -->
                <div class="bg-dark/80 backdrop-blur-md p-4 rounded-2xl mb-4 absolute top-[50px] left-[50px] w-[280px] z-10">
                  <div class="flex flex-row justify-between">
                    <h3 class="text-sm font-semibold text-gray-100 mb-1">Reliable Service</h3>
                    <div class="rounded-full bg-yellow-200/80 w-2 h-2"></div>
                  </div>
                  <p class="text-xs text-gray-100">Track your shipments in real-time with our advanced tracking system</p>
                </div>
              </div>

              <!-- Center Calendar-style Card -->
              <div class="absolute top-[60%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[320px]">
                <div class="bg-dark/20 backdrop-blur-md p-4 rounded-3xl">
                  <!-- Calendar Header -->
                  <div class="flex items-center justify-between mb-4">
                    <div class="flex flex-row items-center justify-between w-full">
                      <h3 class="text-sm font-semibold text-white">Delivery Schedule</h3>
                      <p class="text-xs text-white">24/7 Delivery</p>
                    </div>
                  </div>
                  <!-- Calendar Content -->
                  <div class="space-y-1">
                    <!-- Weekdays -->
                    <div class="grid grid-cols-7 gap-1 text-center">
                      <div class="text-xs font-medium text-gray-300">SUN</div>
                      <div class="text-xs font-medium text-gray-300">MON</div>
                      <div class="text-xs font-medium text-gray-300">TUE</div>
                      <div class="text-xs font-medium text-gray-300">WED</div>
                      <div class="text-xs font-medium text-gray-300">THU</div>
                      <div class="text-xs font-medium text-gray-300">FRI</div>
                      <div class="text-xs font-medium text-gray-300">SAT</div>
                    </div>
                    <!-- Calendar Days -->
                    <div class="grid grid-cols-7 gap-1">
                      <div class="aspect-square flex items-center justify-center text-white">
                        <span class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary/10 cursor-pointer text-sm">15</span>
                      </div>
                      <div class="aspect-square flex items-center justify-center text-white">
                        <span class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary/10 cursor-pointer text-sm">16</span>
                      </div>
                      <div class="aspect-square flex items-center justify-center text-white">
                        <span class="w-8 h-8 flex items-center justify-center rounded-full text-white cursor-pointer text-sm">17</span>
                      </div>
                      <div class="aspect-square flex items-center justify-center text-white">
                        <span class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary/10 cursor-pointer text-sm">18</span>
                      </div>
                      <div class="aspect-square flex items-center justify-center text-white">
                        <span class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary/10 cursor-pointer text-sm">19</span>
                      </div>
                      <div class="aspect-square flex items-center justify-center text-white">
                        <span class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary/10 cursor-pointer text-sm">20</span>
                      </div>
                      <div class="aspect-square flex items-center justify-center text-white">
                        <span class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary/10 cursor-pointer text-sm">21</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CustomSelect from "~/components/ui/CustomSelect.vue"
import OtpInput from "~/components/auth/OtpInput.vue"
import { parsePhoneNumberFromString } from "libphonenumber-js"
const { $toast } = useNuxtApp()

definePageMeta({
  middleware: "guest",
  layout: "register",
})

// Add Tailwind directives to ensure styles are applied
useSeoMeta({
  title: "Create Account - CargoLink",
  description: "Sign up for CargoLink and get started",
})

const router = useRouter()
const authStore = useAuthStore()

// Phone verification state
const phoneVerified = ref(false)
const isVerifying = ref(false)
const showOtpModal = ref(false)
const otpCode = ref("")
const otpCountdown = ref(0)
let otpCountdownInterval = null

// Use computed property with proper phone validation
const isValidPhone = computed(() => {
  if (!formData.phone || !formData.countryCode) return false

  try {
    const fullPhone = formData.countryCode + formData.phone.replace(/\s/g, "")
    const phoneNumber = parsePhoneNumberFromString(fullPhone)
    return phoneNumber ? phoneNumber.isValid() : false
  } catch {
    return false
  }
})

// Use the countries composable
const { countries, isLoading: isLoadingCountries } = useCountries()

// Form data with proper reactivity
const formData = reactive({
  name: "",
  email: "",
  password: "",
  phone: "",
  countryCode: "+255", // Default to Tz
  device_name: navigator?.userAgent || "web",
  isDriver: false,
  driverWorkforceType: "",
  isCarrier: false,
  isForwarder: false,
  isMover: false,
  isWarehouseOperator: false,
})

// Computed properties
const countryOptions = computed(() => {
  if (!countries.value?.length) return []
  return countries.value
})

const selectedCountryOption = computed(() => {
  const selected = countryOptions.value.find((option) => option.code === formData.countryCode)
  return selected || null
})

// Phone styling computed properties
const phoneIconClass = computed(() => {
  if (phoneVerified.value) return "text-green-500"
  if (errors.phone && touched.phone) return "text-red-500"
  if (formData.phone) return "text-dark"
  return "text-gray-500"
})

const phoneInputClass = computed(() => {
  if (phoneVerified.value) return "border-green-500 focus:ring-green-500/20 focus:border-green-500 bg-green-50/30"
  if (errors.phone && touched.phone) return "border-red-500 focus:ring-red-500/20 focus:border-red-500"
  if (formData.phone && isValidPhone.value) return "border-blue-500 focus:ring-blue-500/20 focus:border-blue-500"
  return "border-[#E8ECEF] focus:ring-primary/20 focus:border-primary"
})

// UI state
const showPassword = ref(false)
const isLoading = ref(false)

// Validation state
const errors = reactive({
  name: "",
  email: "",
  password: "",
  phone: "",
  countryCode: "",
})

// Add touched state to show errors only after interaction
const touched = reactive({
  name: false,
  email: false,
  password: false,
  phone: false,
  countryCode: false,
})

// Validation rules
const validateName = (name) => {
  if (!name) return "Full name is required"
  if (name.length < 2) return "Name must be at least 2 characters"
  if (!/^[a-zA-Z\s'-]+$/.test(name)) return "Name can only contain letters, spaces, hyphens and apostrophes"
  return ""
}

const validateEmail = (email) => {
  if (!email) return "Email address is required"
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) return "Please enter a valid email address"
  return ""
}

const validatePassword = (password) => {
  if (!password) return "Password is required"
  if (password.length < 8) return "Password must be at least 8 characters"
  if (!/[A-Z]/.test(password)) return "Password must contain at least one uppercase letter"
  if (!/[a-z]/.test(password)) return "Password must contain at least one lowercase letter"
  if (!/[0-9]/.test(password)) return "Password must contain at least one number"
  return ""
}

const validatePhone = (phone, countryCode) => {
  if (!phone) return "Phone number is required"
  if (!countryCode) return "Country code is required"

  // Find the selected country ISO code (TZ, KE, US, etc.)
  const country = countryOptions.value.find((c) => c.code === countryCode)

  if (!country || !country.label) return "Invalid country selected"
  // ✅ Combine country code and phone
  const fullNumber = `${countryCode}${phone}`.replace(/\s/g, "") // Remove any spaces
  // Parse the phone number
  const parsed = parsePhoneNumberFromString(fullNumber, country.label)

  if (!parsed) return "Invalid phone number format"
  if (!parsed.isValid()) return "Invalid phone number"

  return "" // No error = Valid phone number
}

const validateCountryCode = (countryCode) => {
  if (!countryCode) return "Country code is required"
  return ""
}

// Validate a specific field
const validateField = (fieldName) => {
  touched[fieldName] = true

  switch (fieldName) {
    case "name":
      errors[fieldName] = validateName(formData[fieldName])
      break
    case "email":
      errors[fieldName] = validateEmail(formData[fieldName])
      break
    case "password":
      errors[fieldName] = validatePassword(formData[fieldName])
      break
    case "phone":
      errors[fieldName] = validatePhone(formData[fieldName], formData.countryCode)
      break
    case "countryCode":
      errors[fieldName] = validateCountryCode(formData[fieldName])
      break
  }
}

// Add watchers for real-time validation
watch(
  () => formData.name,
  () => validateField("name"),
)
watch(
  () => formData.email,
  () => validateField("email"),
)
watch(
  () => formData.password,
  () => validateField("password"),
)
watch(
  () => formData.phone,
  () => validateField("phone"),
)
watch(
  () => formData.countryCode,
  () => {
    validateField("countryCode")
    validateField("phone") // Revalidate phone when country changes
  },
)

const formatPhoneNumber = (phone) => {
  // Remove any non-digit characters except plus sign at start
  const formatted = phone.replace(/[^\d+]/g, "")

  // If starts with +, keep it and limit remaining digits to 10
  if (formatted.startsWith("+")) {
    return formatted.slice(0, 1) + formatted.slice(1).slice(0, 15)
  }

  // If no +, just limit to 15 digits
  return formatted.slice(0, 15)
}

const extractCountryCode = (phone) => {
  // Only try to extract if starts with +
  if (!phone.startsWith("+")) {
    return null
  }

  const formatted = formatPhoneNumber(phone)
  // Try to find matching country code
  const matchingCountry = countryOptions.value
    .sort((a, b) => b.code.length - a.code.length) // Sort by code length (longest first)
    .find((country) => {
      const code = country.code.replace("+", "")
      return formatted.startsWith("+" + code)
    })

  if (matchingCountry) {
    const code = matchingCountry.code.replace("+", "")
    // Remove country code from phone number and limit to 10 digits
    const numberWithoutCode = formatted
      .replace(new RegExp(`^\\+?${code}`), "")
      .replace(/^0+/, "") // Remove leading zeros
      .slice(0, 10) // Limit to 10 digits

    return {
      countryCode: matchingCountry.code,
      phoneNumber: numberWithoutCode,
    }
  }
  return null
}

// Update handlePhoneInput to enforce limits while typing
const handlePhoneInput = (event) => {
  const input = event.target
  const value = input.value

  // Format and limit the number
  formData.phone = formatPhoneNumber(value)

  // Reset verification if phone changes
  if (phoneVerified.value) {
    phoneVerified.value = false
  }
}

// Update handlePhoneBlur to only detect country code if starts with +
const handlePhoneBlur = (event) => {
  const value = formData.phone

  // Only try to extract country code if starts with +
  if (value.startsWith("+")) {
    const extracted = extractCountryCode(value)

    if (extracted) {
      // Find the matching country option
      const matchingCountry = countryOptions.value.find((country) => country.code === extracted.countryCode)

      if (matchingCountry) {
        // Update the form data with the matched country
        formData.countryCode = matchingCountry.code
        formData.phone = extracted.phoneNumber
      }
    }
  }

  validateField("phone")
}

// Form submission
// Phone verification methods
const requestPhoneVerification = async () => {
  if (!formData.phone) {
    $toast.error("Please enter a phone number")
    return
  }

  if (!isValidPhone.value) {
    $toast.error("Please enter a valid phone number")
    return
  }

  isVerifying.value = true
  try {
    const fullPhone = formData.countryCode + formData.phone.replace(/\s/g, "")
    const response = await authStore.getAxios().post("/api/v1/auth/otp/request", {
      phone: fullPhone,
      purpose: "registration",
    })

    if (response.data.success) {
      showOtpModal.value = true
      startOtpCountdown(60)
      $toast.success("Verification code sent to your phone")
    }
  } catch (error) {
    $toast.error(error.response?.data?.message || "Failed to send verification code")
  } finally {
    isVerifying.value = false
  }
}

const verifyPhoneOtp = async (code) => {
  if (!code || code.length !== 6) return

  isVerifying.value = true
  try {
    const fullPhone = formData.countryCode + formData.phone.replace(/\s/g, "")
    const response = await authStore.getAxios().post("/api/v1/auth/otp/verify-phone", {
      phone: fullPhone,
      otp_code: code,
      purpose: "registration",
    })

    if (response.data.success) {
      phoneVerified.value = true
      showOtpModal.value = false
      // Store the verified full phone number
      formData.full_phone = fullPhone
      $toast.success("Phone number verified successfully!")
    }
  } catch (error) {
    $toast.error(error.response?.data?.message || "Invalid verification code")
    otpCode.value = ""
  } finally {
    isVerifying.value = false
  }
}

const closeOtpModal = () => {
  showOtpModal.value = false
  otpCode.value = ""
}

const startOtpCountdown = (seconds) => {
  otpCountdown.value = seconds
  if (otpCountdownInterval) clearInterval(otpCountdownInterval)

  otpCountdownInterval = setInterval(() => {
    otpCountdown.value--
    if (otpCountdown.value <= 0) {
      clearInterval(otpCountdownInterval)
    }
  }, 1000)
}

const handleSubmit = async () => {
  // Check phone verification first
  if (!phoneVerified.value) {
    $toast.error("Please verify your phone number before registering")
    return
  }

  // Mark all fields as touched
  Object.keys(touched).forEach((field) => {
    touched[field] = true
    validateField(field)
  })

  // Check if there are any errors
  const hasErrors = Object.values(errors).some((error) => error !== "")

  if (hasErrors) {
    return
  }

  isLoading.value = true

  try {
    // full_phone is already set during verification (formData.full_phone = fullPhone)
    // No need to set it again here
    if (formData.isDriver && !formData.driverWorkforceType) {
      $toast.error("Please choose whether you are applying for CityXpress or InTransit.")
      return
    }

    const result = formData.isDriver
      ? await authStore.registerDriverWorkforce(formData, formData.driverWorkforceType)
      : await authStore.register(formData)

    if (result.success) {
      $toast.success(result.message)

      // Redirect based on user type
      if (formData.isForwarder) {
        router.push("/auth/forwarder/apply")
      } else if (formData.isDriver) {
        router.push(`/auth/driver/apply?type=${formData.driverWorkforceType}`)
      } else if (formData.isCarrier) {
        router.push("/auth/carrier/apply")
      } else if (formData.isMover) {
        router.push("/auth/mover/apply")
      } else if (formData.isWarehouseOperator) {
        router.push("/warehouse-operator")
      } else {
        router.push("/auth/verify")
      }
    } else {
      // Handle API errors
      $toast.error("Registration failed. Please try again.")
      if (result.errors) {
        Object.keys(result.errors).forEach((field) => {
          errors[field === "full_phone" ? "phone" : field] = result.errors[field][0]
        })
      } else {
        errors.value = result.error || "Registration failed. Please try again."
      }
    }
  } catch (err) {
    $toast.error("Registration failed. Please try again.")
  } finally {
    isLoading.value = false
  }
}
const floatingEnabled = ref(false)
const mouseX = ref(0)
const mouseY = ref(0)
const startFloating = () => {
  floatingEnabled.value = true
}

const handleMouseMove = (e) => {
  const { innerWidth, innerHeight } = window
  // Center the mouse coordinates to (0, 0) in the middle of the page
  mouseX.value = (e.clientX - innerWidth / 2) / (innerWidth / 2)
  mouseY.value = (e.clientY - innerHeight / 2) / (innerHeight / 2)
}
const floatingStyle = computed(() => {
  if (!floatingEnabled.value) {
    return {} // No transform before transition ends
  }

  const maxMovement = 10 // pixels
  const x = -mouseX.value * maxMovement
  const y = -mouseY.value * maxMovement

  return {
    transform: `translate3d(${x}px, ${y}px, 0)`,
    transition: "transform 0.2s ease-out",
  }
})

const showContent = ref(false)

onMounted(() => {
  window.addEventListener("mousemove", handleMouseMove)
  showContent.value = true
})

onBeforeUnmount(() => {
  if (otpCountdownInterval) clearInterval(otpCountdownInterval)
})

onUnmounted(() => {
  window.removeEventListener("mousemove", handleMouseMove)
})
</script>

<style></style>
